export default __webpack_public_path__ + "static/media/Talent_ElementalRanger.4ecbe7a6.png";